export const epicToAMS360Id = 'D43DE030-D306-41C8-A743-619C51938CD0';

export const tamToAMS360Id = '250F0D9E-E5F0-4F31-80EA-3DE872343ED6';

export const ams360ToAMS360Id = '11C6C3A5-3D63-4B6F-982E-EFFCB03A3C5E';

export const miniToAMS360Id = '68449976-96AB-4EC3-A9CE-321FDBA7DD4E';

export const ndtAms360ToAMS360Id = 'D976D412-5517-428E-85DA-53704508F8E6';
